import axios from "axios";
import config from "../../config";
import {
  MdaClaimDecision,
  MdaClaimReferenceSearchRequest,
  MdaClaimRuleBreak,
  MdaClaimsRequest,
  MdaClaimsResponse,
  MdaFilterOptionsResponse,
  MdaMarkClaimsAsReadRequest,
} from "./mda-types";

const apiUrl = config.api;

export const getMdaFilterOptions = async (
  clientId: number,
): Promise<MdaFilterOptionsResponse> => {
  const response = await axios.post<MdaFilterOptionsResponse>(
    `${apiUrl}/scoring/mda/filters/client/${clientId}/options`,
  );

  return response.data;
};

export const getMdaClaims = async (
  clientId: number,
  body: MdaClaimsRequest,
): Promise<MdaClaimsResponse> => {
  const response = await axios.post<MdaClaimsResponse>(
    `${apiUrl}/scoring/mda/claims/search/${clientId}`,
    body,
  );

  return response.data;
};

// Exact match across every client. The reference goes in the body because it
// can contain "/".
export const searchMdaClaimsByReference = async (
  claimReference: string,
): Promise<MdaClaimsResponse> => {
  const body: MdaClaimReferenceSearchRequest = { claimReference };
  const response = await axios.post<MdaClaimsResponse>(
    `${apiUrl}/scoring/mda/claims/search/reference`,
    body,
  );

  return response.data;
};

export const getMdaClaimDecisions = async (
  entityId: string,
): Promise<MdaClaimDecision[]> => {
  const response = await axios.get<MdaClaimDecision[]>(
    `${apiUrl}/scoring/mda/claims/${entityId}/decisions`,
  );

  return response.data;
};

export const getMdaClaimRuleBreaks = async (
  entityId: string,
): Promise<MdaClaimRuleBreak[]> => {
  const response = await axios.get<MdaClaimRuleBreak[]>(
    `${apiUrl}/scoring/mda/claims/${entityId}/rule-breaks`,
  );

  return response.data;
};

export const markMdaClaimsAsRead = async (
  body: MdaMarkClaimsAsReadRequest,
): Promise<void> => {
  await axios.post(`${apiUrl}/scoring/mda/claims/mark-as-read`, body);
};
